define("shared/components/shared/ui/navigation-arrows", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <a
    role="button" 
    class="qa--searchProfile_prev_btn {{if this.showLeftArrow "" "u--hide"}}"
    {{on "click" (fn @navigate false)}}>
    {{svg-jar "nav-left" class=(concat "o--icon cTD--navigationArrow--prev" (if this.needsNarrowArrows " is--narrow" ""))}}
  </a>
  <a
    role="button"
    class="qa--searchProfile_nxt_btn {{if this.showRightArrow "" "u--hide"}}"
    {{on "click" (fn @navigate true)}}>
    {{svg-jar "nav-right" class=(concat "o--icon cTD--navigationArrow--next" (if this.needsNarrowArrows " is--narrow" ""))}}
  </a>
  */
  {
    "id": "CejElYrM",
    "block": "[[[11,3],[24,\"role\",\"button\"],[16,0,[29,[\"qa--searchProfile_prev_btn \",[52,[30,0,[\"showLeftArrow\"]],\"\",\"u--hide\"]]]],[4,[38,1],[\"click\",[28,[37,2],[[30,1],false],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,3],[\"nav-left\"],[[\"class\"],[[28,[37,4],[\"o--icon cTD--navigationArrow--prev\",[52,[30,0,[\"needsNarrowArrows\"]],\" is--narrow\",\"\"]],null]]]]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,3],[24,\"role\",\"button\"],[16,0,[29,[\"qa--searchProfile_nxt_btn \",[52,[30,0,[\"showRightArrow\"]],\"\",\"u--hide\"]]]],[4,[38,1],[\"click\",[28,[37,2],[[30,1],true],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,3],[\"nav-right\"],[[\"class\"],[[28,[37,4],[\"o--icon cTD--navigationArrow--next\",[52,[30,0,[\"needsNarrowArrows\"]],\" is--narrow\",\"\"]],null]]]]],[1,\"\\n\"],[13]],[\"@navigate\"],false,[\"if\",\"on\",\"fn\",\"svg-jar\",\"concat\"]]",
    "moduleName": "shared/components/shared/ui/navigation-arrows.hbs",
    "isStrictMode": false
  });

  let NavigationArrowsComponent = (_class = class NavigationArrowsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "mediaNavigation", _descriptor, this);
    }

    get needsNarrowArrows() {
      return this.mediaNavigation.needsNarrowArrows;
    }

    get showLeftArrow() {
      return !this.mediaNavigation.firstMediaItem;
    }

    get showRightArrow() {
      return !this.mediaNavigation.lastMediaItem;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = NavigationArrowsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NavigationArrowsComponent);
});